import { DestinationAdapter } from './base-adapter.js';

class GA4Adapter extends DestinationAdapter {
  get name() {
    return 'GA4';
  }

  isInitialized() {
    return typeof window.gtag === 'function';
  }

  async initialize(credentials) {
    const { measurementId } = credentials;

    if (!measurementId) {
      console.error('EventFoundry: GA4 adapter missing measurementId');
      return false;
    }

    // Validate measurement ID format
    if (!measurementId.match(/^G-[A-Z0-9]+$/)) {
      console.error(`EventFoundry: Invalid GA4 measurement ID format: ${measurementId}`);
      return false;
    }

    // Check if gtag already exists
    if (this.isInitialized()) {
      console.log('EventFoundry: Using existing GA4 installation');
      return true;
    }

    // Inject gtag.js script
    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    script.async = true;
    document.head.appendChild(script);

    // Initialize dataLayer
    window.dataLayer = window.dataLayer || [];
    window.gtag = function() { dataLayer.push(arguments); };

    // Wait for script to load
    await new Promise((resolve, reject) => {
      let resolved = false;

      script.onload = () => {
        if (!resolved) {
          resolved = true;
          resolve();
        }
      };

      script.onerror = () => {
        if (!resolved) {
          resolved = true;
          console.error('EventFoundry: Failed to load gtag.js');
          reject(new Error('gtag.js failed to load'));
        }
      };

      setTimeout(() => {
        if (!resolved) {
          resolved = true;
          console.warn('EventFoundry: gtag.js load timeout');
          resolve();
        }
      }, 10000);
    });

    // Verify gtag exists
    if (!this.isInitialized()) {
      console.error('EventFoundry: gtag not available after load');
      return false;
    }

    // Configure GA4
    window.gtag('js', new Date());
    window.gtag('config', measurementId);

    console.log('EventFoundry: GA4 initialized successfully');
    return true;
  }

  fireEvent(eventKey, params) {
    if (!this.isInitialized()) {
      console.error('EventFoundry: gtag not available - cannot fire event');
      return;
    }

    // Fire event with beacon transport for reliable delivery
    window.gtag('event', eventKey, {
      ...params,
      transport_type: 'beacon'
    });
  }
}

export const ga4Adapter = new GA4Adapter();
